<ng-container *ngIf="!ssr && translations$ | async as translations">
	<account-bankid_auth
		class="obg-m-login-bankid-container"
		[images]="images$ | async"
		[translations]="translations"
		[qrCodeComponentTranslations]="qrCodeComponentTranslations$ | async"
		view="{{view}}"
		qrCodeComponentView="{{qrCodeComponentView}}"
		[genericLoginError]="genericLoginError"
		[pollingTimeout]="pollingTimeout$ | async"
		[invalidCredentialsError]="invalidCredentialsError"
		[initializeVerificationFail]="initializeVerificationFail"
		[qrCodeComponentTextQr]="qrCode$ | async"
		[errorComingFrom]="errorComingFromObservable$ | async"
		[transactionTimeLeft]="countdownInterval$ | async"
		(bankIdOpenEvent)="onBankIdOpenEvent()"
		(bankIdOnAnotherDeviceEvent)="onBankIdOnAnotherDeviceEvent()"
		(createAccountEvent)="onCreateAccountEvent()"
		(cancelPollingEvent)="onCancelPollingEvent()"
		(retryBankIdEvent)="onRetryBankIdEvent()"
		(qrCodeCurrentDeviceEvent)="onQrCodeCurrentDeviceEvent()"
		(loginWithEmailAndPasswordEvent)="onLoginWithEmailAndPasswordEvent()"
		(showErrorAlertEvent)="onShowErrorAlertEvent($event)"
		(closeErrorAlertEvent)="onCloseErrorAlertEvent()"
		(openSupportPageInNewTabEvent)="onOpenSupportPageInNewTabEvent()"
		(extendTransactionTimeLeft)="extendTimeLeft()"
	/>
</ng-container>
